import { allAttributes, allChildNodes, attribute } from 'func-xml';
import { compose, reject } from 'ramda';
import { isNamespaceDeclaration } from '../../../utility/xmlHelpers';
import { getValidNode } from './qRules.node.helpers';
import { setIsSwappingDom } from './qdabraRulesDs.helpers';
import {
    getDataSource,
    getDataSourceObject,
} from './qRules.dataSource.helpers';

const getAttributesToCopy = compose(
    reject(isNamespaceDeclaration),
    allAttributes,
);

// docToInsert should be the document element of the source document
// (DataSourceCollection, String, DOMElement) -> Promise[void]
export const swapDomContents = async (
    dataSources,
    targetDsName,
    docToInsert,
) => {
    try {
        const targetDom = getDataSource(dataSources, targetDsName);
        const targetDataSourceObject = getDataSourceObject(
            dataSources,
            targetDsName,
        );

        const targetRootElDsNode = getValidNode(
            targetDom,
            '/*',
            'Unable to locate target data source root.',
        );
        const targetRootElNode = targetRootElDsNode.getNode();

        // Replace main DOM with obtained document.
        await setIsSwappingDom(dataSources, true);

        for (const childNode of targetRootElDsNode.childNodes()) {
            childNode.deleteSelf();
        }

        for (const childNode of allChildNodes(docToInsert)) {
            targetRootElNode.appendChild(childNode.cloneNode(true));
        }

        const attributeNodes = getAttributesToCopy(docToInsert);

        for (const attrib of attributeNodes) {
            const matchingAttribute = attribute(
                attrib.localName,
                attrib.namespaceURI,
            )(targetRootElNode);

            if (matchingAttribute) {
                matchingAttribute.value = attrib.value;
            }

            // TODO?: Add attributes if they are missing?
        }

        //assign ids.
        targetDataSourceObject.assignIds(targetRootElNode);
    } finally {
        await setIsSwappingDom(dataSources, false);
    }
};
